import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
@Component({
  selector: 'flowaccount-shopee-lazada-benefit',
  templateUrl: './shopee-lazada-benefit.component.html',
  styleUrls: ['./shopee-lazada-benefit.component.scss'],
})
export class ShopeeLazadaBenefitComponent {
  public dataList = [
    {
      text: 'SHOPEE_LAZADA.BENEFIT.LISTS.TEXT_1',
    },
    {
      text: 'SHOPEE_LAZADA.BENEFIT.LISTS.TEXT_2',
    },
    {
      text: 'SHOPEE_LAZADA.BENEFIT.LISTS.TEXT_3',
    },
    {
      text: 'SHOPEE_LAZADA.BENEFIT.LISTS.TEXT_4',
    },
  ]
  public getAltText = this.translate.currentLang === 'th' ? 'เชื่อมต่อร้านค้าออนไลน์' : 'Connecting Online Stores'
  constructor(public translate: TranslateService) {}
}
